import {
  buffers,
  eventChannel,
  END,
} from 'redux-saga';

interface Params {
  url: string;
  method?: 'GET' | 'POST' | 'PATCH';
  headers?: {
    [key: string]: string;
  };
  formData?: any;
  responseType?: '' | 'text' | 'arraybuffer';
}

const createXMLHttpRequestChannel = ({
  url,
  method = 'POST',
  headers,
  formData,
  responseType = 'text',
}: Params) => eventChannel(
  (emitter) => {
    const xhr = new XMLHttpRequest();

    const onLoadStart = () => {
      emitter({ progress: 0 });
    };
    const onProgress = (e: ProgressEvent) => {
      if (e.lengthComputable) {
        const progress = Math.floor((e.loaded / e.total) * 100);
        emitter({ progress });
      }
    };
    const onFailure = () => {
      emitter({ err: new Error('Request failed') });
      emitter(END);
    };
    const listner = (method === 'POST' || method === 'PATCH') ? xhr.upload : xhr;
    listner.addEventListener('loadstart', onLoadStart);
    listner.addEventListener('progress', onProgress);
    listner.addEventListener('error', onFailure);
    listner.addEventListener('abort', onFailure);
    xhr.onreadystatechange = () => {
      const { readyState, status } = xhr;
      const type = xhr.getResponseHeader('Content-Type');
      if (readyState === 4) {
        if (status >= 400) {
          onFailure();
        } else {
          emitter({
            result: type === 'application/json'
              ? JSON.parse(xhr.response)
              : xhr.response,
            success: true,
          });
          emitter(END);
        }
      }
    };

    xhr.open(method, url, true);

    if (headers) {
      Object.keys(headers).forEach(key => {
        xhr.setRequestHeader(key, headers[key]);
      });
    }

    xhr.responseType = responseType;
    xhr.send(formData || null);

    return () => {
      listner.removeEventListener('loadstart', onLoadStart);
      listner.removeEventListener('progress', onProgress);
      listner.removeEventListener('error', onFailure);
      listner.removeEventListener('abort', onFailure);
      xhr.onreadystatechange = null;
      xhr.abort();
    };
  },
  buffers.sliding(2),
);

export default createXMLHttpRequestChannel;
